<template>
  <div class="page" id="page-home" style="overflow: hidden;">
    <div class="section" id="section-home-landing">
      <carousel
        :autoplay="true"
        :autoplayTimeout="5000"
        :items="1"
        :dots="false"
        :nav="false"
        :loop="true"
        ref="mainCarousel"
      >
        <div
          class="landing-carousel-item2"
          v-for="n in 11"
          :key="n"
          :class="`main-${n}`"
        >
          <div class="carousel-content">
            <img alt="로고" src="/static/carousel-icon.png" />
            <h1>make sure your sure</h1>
            <p>{{ main[n % main.length].text }}</p>
            <a class="link-button" :href="main[n % main.length].href">
              <h3>{{ main[n % main.length].buttonText }}</h3>
            </a>
          </div> 
        </div>
      </carousel>
      
      <div class="carousel-nav">
        <button class="up" @click="carouselMove('prev', 'mainCarousel')">
          <img alt="이전 이미지로 이동" src="/static/btn_arrow_up.png" />
        </button>
        <button @click="carouselMove('next', 'mainCarousel')">
          <img alt="다음 이미지로 이동" src="/static/btn_arrow_down.png" />
        </button>
      </div>

      <div class="insurance-icon">
        <VueSlickCarousel
          :slidesToShow="6"
          :responsive="[
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 6,
                rows: 1
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 3,
                rows: 2,
              }
            },
          ]"
        >
          <template #prevArrow>
            <button id="insurance-icon-prev" class="arrow-btn" @click="carouselMove('prev', 'iconCarousel')">
              <img alt="이전으로 이동" src="/static/main/icon/arrow_left.png" />
            </button>
          </template>

          <div
            v-for="(icon, index) in insuranceIcon"
            :key="index"
            class="insurance-icon-list"
            style="width: 120px"
            ref="insuranceIconList"
            @mouseover="mouseoverIcon"
          >
            <a :href="`/compare?tab=${icon.name}`">
              <div><img :src="icon.src" /></div>
              <p>{{ icon.name }}</p>
            </a>
          </div>

          <template #nextArrow>
            <button id="insurance-icon-next" @click="carouselMove('next', 'iconCarousel')">
              <img alt="다음으로 이동" src="/static/main/icon/arrow_right.png" />
            </button>
          </template>
        </VueSlickCarousel>
      </div>
    </div>

    <Footer/>
  </div>
</template>
<script>
import carousel from 'vue-owl-carousel'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import Footer from "../../view/layout/Footer.vue"
import HomeAdModal from '@/components/Elements/HomeAdModal.vue';

export default {
  components: {
    carousel,
    VueSlickCarousel,
    Footer,
    HomeAdModal
  },
  data(){
    return {
      line: "/static/banner-line.png",
      insurance_length: 12,
      statusMore: false,
      main: [
        { text: '37년간 사랑받은 인슈넷FC의 혜택 6대 사은', href: '/gift?tab=24시간 주차알림', buttonText: '자세히 보기' },
        { text: '13개 보험사 전문적인 비교견적 합리적인 선택 인슈넷FC', href: '/compare?tab=자동차보험', buttonText: '비교견적 신청' },
        { text: '37년간 변함없이 고객 편에서 약속한 5대 보증', href: '/guarantee?tab=최저 보험료', buttonText: '자세히 보기' },
      ],
      insurances: [
        { name: "자동차보험", src: "/static/home-insurance-1.png", query: "자동차보험" },
        { name: "운전자보험", src: "/static/home-insurance-2.png", query: "운전자보험" },
        { name: "실손의료보험", src: "/static/home-insurance-3.png", query: "실손의료보험" },
        { name: "암보험", src: "/static/home-insurance-4.png", query: "암보험" },
        { name: "어린이보험", src: "/static/home-insurance-5.png", query: "어린이보험" },
        { name: "태아보험", src: "/static/home-insurance-6.png", query: "태아보험" },
        { name: "정기보험", src: "/static/home-insurance-7.png", query: "정기보험" },
        { name: "종신보험", src: "/static/home-insurance-8.png", query: "종신보험" },
        { name: "화재보험", src: "/static/home-insurance-9.png", query: "화재보험" },
        { name: "연금보험", src: "/static/home-insurance-10.png", query: "연금보험" },
        { name: "치아보험", src: "/static/home-insurance-11.png", query: "치아보험" },
        { name: "치매보험", src: "/static/home-insurance-12.png", query: "치매보험" },
        { name: "펫보험", src: "/static/home-insurance-13.png", query: "펫보험" },
      ],
      notice_data: [],
      openItem: -1,
      insuranceIcon: [
        { name: '자동차보험', src: '/static/main/a/car_icon.png', merge: 1 },
        { name: '운전자보험', src: '/static/main/a/driver_icon.png', merge: 2 },
        { name: '실손의료보험', src: '/static/main/a/medical_icon.png', merge: 3 },
        { name: '암보험', src: '/static/main/a/cancer_icon.png', merge: 1 },
        { name: '어린이보험', src: '/static/main/a/children_icon.png', merge: 2 },
        { name: '태아보험', src: '/static/main/a/fetal_icon.png', merge: 3 },
        { name: '정기보험', src: '/static/main/a/term_icon.png', merge: 1 },
        { name: '종신보험', src: '/static/main/a/whole_life_icon.png', merge: 2 },
        { name: '화재보험', src: '/static/main/a/fire_icon.png', merge: 3 },
        { name: '연금보험', src: '/static/main/a/pension_icon.png', merge: 1 },
        { name: '치아보험', src: '/static/main/a/dental_icon.png', merge: 2 },
        { name: '치매보험', src: '/static/main/a/demential_icon.png', merge: 3 },
        { name: '펫보험', src: '/static/main/a/pet_icon.png', merge: 1 },
      ],
      refresh: 0,
    }
  },
  created() {
    // location.href='/estimate/consultation'
    this.updatePage(1);
  },
  mounted(){
    // this.$refs.modalHomeAdModal.show();
    document.getElementsByClassName('slick-active')[0].children[0].className = 'insurance-active';
  },
  methods: {
    clickMore(){
      if(!this.statusMore){
        this.insurance_length = 13;
        this.statusMore = true;
      }
      else{
        this.insurance_length = 12;
        this.statusMore = false;
      }
    },
    updatePage(page){
      this.$data.currentPage = page;
      // this.$store.dispatch( "post/getItems", { page: 1, size: 5, post_type: "notice" } ).then( res => {
      //   this.notice_data = res.data.data.items;
      // });
    },
    callNumber(){
      location.href = "tel:" + "16681100";
    },
    closeModal(){
      this.$refs.modalHomeAdModal.close();
    },
    test(){
      location.href="https://www.naver.com"
    },
    goEvent(){
      window.open('https://event.insunetfc.com/', '_blank');
    },
    carouselMove(type, refName) {
      const id = type === 'prev' ? 'prevHandler' : 'nextHandler';
      const $eId = this.$refs[refName];
      document.getElementById($eId[id]).click();
    },
    resizeEvent(event) {
      const { target } = event;
      const eventName = Object.keys(target)[1];
      console.log(event)

      target[eventName].handle('update');
      this.refresh++;
    },
    updateEvent(event) {
      console.log(event)
    },
    mouseoverIcon() {
      const initActiveEl = document.getElementsByClassName('insurance-active')[0];
      if (initActiveEl) {
        initActiveEl.className = '';
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .center.aligned {
    text-align: center;
  }
  a.link-button {
    border: 2px solid #174de5;
    padding: 0rem 1.5rem;
    font-size: 21px;
    font-weight: 400;
    border-radius: 4px;
    color: #174de5;
    display: inline-block;
    margin-top: 3rem;
  }
  a.event-button {
    border: 2px solid #44cc2f;
    background: #f0fff3;
    padding: 0rem 1.5rem;
    font-size: 21px;
    font-weight: 400;
    border-radius: 4px;
    color: #35af23;
    display: inline-block;
    margin-top: 3rem;
  }
  #site-footer {
    margin-top: 2.5*$unit;
  }
</style>